import type { AvatarSize } from '@keyvue/one-ui';

const resizedUploadUrl = (url: string, size: { width?: number, height?: number } = {}) => {
    // Determine size part
    let sizePart: string | null = null;
    if (size.width && size.height) {
        sizePart = `${size.width}x${size.height}`;
    } else if (size.width) {
        sizePart = `${size.width}x`;
    } else if (size.height) {
        sizePart = `x${size.height}`;
    }

    // Check size part
    if (sizePart !== null) {
        const urlParts = url.split('/');
        urlParts.splice(-1, 0, sizePart);

        return urlParts.join('/');
    }

    return url;
};

const resizedToSizeUploadUrl = (url: string, size: AvatarSize) => {
    const sizes = {
        sm: 18,
        md: 24,
        lg: 36,
        xl: 48,
    };

    const sizeInPixels = Math.ceil(sizes[size] * window.devicePixelRatio);

    return resizedUploadUrl(url, { width: sizeInPixels, height: sizeInPixels });
};

export {
    resizedUploadUrl,
    resizedToSizeUploadUrl,
};
